import { Fragment } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Feedback from './pages/CreateFeedback'
import Success from './pages/Success'

export default function RoutesApp() {

  return (
    <BrowserRouter>
      <Fragment>
        <Routes>
          <Route exact path="/" element={<Feedback />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/success" element={<Success />} />
          <Route path="*" element={<Feedback />} />
        </Routes>
      </Fragment>
    </BrowserRouter>
  )
}